import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { alertActions, authActions } from '../../_store';
import SuccessMessage from '../../_components/successMessage/successMessage';
import ErrorMessage from '../../_components/errorMessage/errorMessage';

export { ForgotPassword };

function ForgotPassword() {
    // Defaults
    const dispatch = useDispatch();

    // State
    const [forgotPasswordMsg, setForgotPasswordMsg] = useState(false);
    const [errorLogin, setErrorLogin] = useState(null);

    // Initial setup for navigation props
    dispatch(
        authActions.setNavProps({
            title: 'LOGIN TO SPLENDI',
            button: 'Register',
            action: '../register',
            status: "Don't have an account?",
        })
    );

    // UseEffects
    useEffect(() => {
        setForgotPasswordMsg(false);
        setErrorLogin(null);
    }, []);

    const validationSchema = Yup.object().shape({
        username: Yup.string().required('Email is required'),
    });

    const { register, handleSubmit, formState } = useForm({
        resolver: yupResolver(validationSchema),
    });
    const { errors, isSubmitting } = formState;

    async function onSubmit({ username }) {
        dispatch(alertActions.clear());
        setForgotPasswordMsg(false);
        setErrorLogin(null);
        try {
            const reqData = {
                username: String(username).toLowerCase(),
            };

            const response = await dispatch(
                authActions.forgotPassword(reqData)
            ).unwrap();

            if (response && response.statusCode === 200) {
                setForgotPasswordMsg(true);
            }
            if (response && response.statusCode === 400) {
                setErrorLogin(response.message);
            }
        } catch (error) {
            dispatch(alertActions.error(error));
            setForgotPasswordMsg(false);
        }
    }

    const renderTemplate = () => {
        dispatch(
            authActions.setNavProps({
                title: 'FORGOT PASSWORD',
                button: 'Login',
                action: '../login',
                status: 'Already signed up?',
            })
        );
        return (
            <div className='card-body'>
                <h2 className='card-header no-border text-center'>
                    Forgot Password?
                </h2>
                <p
                    style={{ maxWidth: '300px' }}
                    className='mt-4 mb-4 text-center mx-auto'
                >
                    Enter your email below to reset your password.
                </p>
                {/* error message */}
                {errorLogin ? (
                    <div className='mb-3 ml-6'>
                        <ErrorMessage message={errorLogin} />
                    </div>
                ) : null}
                {/* success message */}
                {forgotPasswordMsg ? (
                    <div className='mb-3 ml-6'>
                        <SuccessMessage message='YOU SHOULD RECEIVE AN EMAIL SHORTLY WITH FURTHER INSTRUCTIONS.' />
                    </div>
                ) : null}
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='mb-3 ml-6'>
                        <label className='form-label fw-bold'>Email</label>
                        <input
                            name='username'
                            type='text'
                            {...register('username')}
                            className={`form-control ${
                                errors.username ? 'is-invalid' : ''
                            }`}
                        />
                        <div className='invalid-feedback'>
                            {errors.username?.message}
                        </div>
                    </div>
                    <div className='d-grid gap-2 ml-6'>
                        <button
                            disabled={isSubmitting}
                            className='btn btn-black mb-2 w-100'
                        >
                            {isSubmitting && (
                                <span className='spinner-border spinner-border-sm me-1'></span>
                            )}
                            SUBMIT
                        </button>
                        <Link to='/login'>
                            <button className='btn btn-custom-1 text-primary w-100 text-center'>
                                Back to Login
                            </button>
                        </Link>
                    </div>
                </form>
            </div>
        );
    };

    return (
        <div className='card no-border m-md-3 pt-4 pb-5 d-flex align-items-center'>
            {renderTemplate()}
        </div>
    );
}
